import { useState } from "react";

import { Button } from "@/components/ui/button";

import { FramingSceneRow } from "./FramingSceneRow";
import {
  INITIAL_SCENE_ROWS,
  type FramingSectionFilter,
} from "./framingSectionModel";
import type { PrioritizedFramingScene } from "./framingScenePriority";

/**
 * Failure-first scene rail (CROP-WB-005): at most four prioritized rows
 * initially, then explicit expansion. No media requests happen here.
 */
export function FramingSceneRail({
  scenes,
  filter,
  onInspect,
}: {
  scenes: readonly PrioritizedFramingScene[];
  filter: FramingSectionFilter;
  onInspect: (sceneId: string) => void;
}) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? scenes : scenes.slice(0, INITIAL_SCENE_ROWS);
  if (scenes.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        {filter === "crop_feedback"
          ? "Crop feedback exists but no scene could be correlated; the " +
            "reports remain in the uncorrelated bucket."
          : "No scenes match this filter."}
      </p>
    );
  }
  return (
    <div className="space-y-2">
      {visible.map((entry) => (
        <FramingSceneRow
          key={entry.scene.sceneId}
          entry={entry}
          onInspect={onInspect}
        />
      ))}
      {scenes.length > INITIAL_SCENE_ROWS ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setExpanded((value) => !value)}
          aria-expanded={expanded}
        >
          {expanded
            ? "Show fewer scenes"
            : `Show ${scenes.length - INITIAL_SCENE_ROWS} more scenes`}
        </Button>
      ) : null}
    </div>
  );
}
